import React from 'react';
import { Sidebar } from '@pascal/pascal-core';
import ResultWr from './resultWr';
import { resultColumns } from './columns';

export function PayoutsAndResultsContainer() {
  return <Sidebar position='right' results={ResultWr} resultsColumns={resultColumns} />;
}
